<div class="rms-option-toggle" [class.disabled]="disabled" role="radiogroup">
  <div class="option-toggle-thumb"
       *ngIf="selectedIndex >= 0"
       [class.emphasized]="emphasizeNonDefault && value !== defaultValue"
       [style.width]="'calc((100% - 4px) / ' + options.length + ')'"
       [style.transform]="'translateX(calc(100% * ' + selectedIndex + '))'"></div>
  <button type="button"
          class="option-toggle-segment"
          *ngFor="let option of options"
          role="radio"
          [class.selected]="option.value === value"
          [attr.aria-checked]="option.value === value"
          [disabled]="disabled"
          (click)="selectOption(option)">
    <span *ngIf="useHtmlLabel; else plainLabel" [innerHTML]="option.label"></span>
    <ng-template #plainLabel>{{ option.label }}</ng-template>
  </button>
</div>
